import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./screens/login";
import Recovery from './screens/recovery';
import NewPassword from './screens/recovery/new-password';
import ForcePassword from './screens/recovery/force-password';
import Signstatement from './screens/signstatement';
import Home from './screens/home';
import Layout from './screens/layout';
import Users from './screens/users';
import Changepass from './screens/changepass';
import Notifications from './screens/ddjj';
import Documents from './screens/ddjj/documents';
import Funds from './screens/setting/funds';
import Tickers from './screens/setting/tickers';
import Accounts from "./screens/setting/accounts";
import Operations from './screens/operations/operations';
import Reports from "./screens/reports/reports";
import ReportsMiddle from "./screens/reports/reports-middle"
import MesaDashboard from "./screens/mesa/mesa-dashboard";
import MesaOperations from "./screens/mesa/mesa-operations";
import MesaDayOperations from "./screens/mesa/mesa-day-operations";
import MesaEscoOperation from "./screens/mesa/mesa-esco-operation";
import DocumentNew from './screens/ddjj/document-new';
import DocumentEdit from './screens/ddjj/document-edit';
import DocumentClone from './screens/ddjj/document-clone';
import Authorizations from './screens/authorizations';
import SendAuth from './screens/setting/sendauth';
import OperationsFCIEdit from './screens/operations/operations-fci-edit';
import PortfolioManagers from './screens/setting/portfolio-managers';
import ManagementCompanyApproval from './screens/signstatement/management-company-approval';
import ManagementCompanyReject from './screens/signstatement/management-company-reject';
import PublicAuthorization from './screens/authorizations/public-authorization';

import { MyContext } from "./context/MyContext";
import { PusherProvider } from "./context/PusherContext";
import MesaDashboardReport from './screens/mesa/mesa-dashboard-report';

function App() {

  const [userProfile, setUserProfile] = useState(sessionStorage.getItem("userProfile"));
  const [toggleMenu, setToggleMenu] = useState(true);

  const handleLogout = () => {
    sessionStorage.removeItem("userProfile");
    sessionStorage.removeItem("menuOption");
    sessionStorage.removeItem("submenuOption");
    setUserProfile(null);
  };

  return (
    <div className="App">
      { !userProfile ?
        <Router>
          <Routes>
            <Route path='/' element={<Login/>}></Route>
            <Route path='/register' element={<Recovery/>}></Route>
            <Route path='/newpassword' element={<NewPassword/>}></Route>
            <Route path='/force-password' element={<ForcePassword/>}></Route>
            <Route path="signstatement/:token" element={<Signstatement />} />
            <Route path="management-company-approval/:fundOperationId" element={<ManagementCompanyApproval />} />
            <Route path="management-company-reject/:fundOperationId" element={<ManagementCompanyReject />} />
            <Route path="public-authorization" element={<PublicAuthorization />} />
            <Route path="public-authorization/:opeToken/:fundToken" element={<PublicAuthorization />} />

          </Routes>
        </Router>
      :
      <MyContext.Provider value={{ toggleMenu, setToggleMenu, handleLogout }}>
      <PusherProvider>
        <Router>
          <Routes>
            {/* PUBLIC - no requiere sesión */}
            <Route path="public-authorization" element={<PublicAuthorization />} />
            <Route path="public-authorization/:opeToken/:fundToken" element={<PublicAuthorization />} />

            <Route path="/" element={<Layout />}>
              <Route path="/" element={<Home />} />
              {/* <Route path="/force-password" element={<ForcePassword />} /> */}
              <Route path="users" element={<Users />} />
              <Route path="changepass" element={<Changepass />} />
              {/* DD.JJ. */}
              <Route path="notifications" element={<Notifications />} />
              <Route path="documents" element={<Documents />} />
              <Route path="documentNew" element={<DocumentNew />} />
              <Route path="documentEdit/:docid" element={<DocumentEdit />} />
              <Route path="documentClone/:docid" element={<DocumentClone />} />
              {/* OPERATIONS */}
              <Route path="operations" element={<Operations />} />
              <Route path="funds/:id" element={<OperationsFCIEdit />} />

              {/* MESA */}
              <Route index path="mesaDashboard" element={<MesaDashboard />} />
              <Route index path="mesaDashboardReport" element={<MesaDashboardReport />} />
              <Route path="mesaOperations" element={<MesaOperations />} />
              <Route path="mesaDayOperations" element={<MesaDayOperations />} />
              <Route path="mesaEscoOperations" element={<MesaEscoOperation />} />
              {/* REPORTS */}
              <Route path="reportOperation" element={<Reports />} />
              <Route path="reportOperationMiddle" element={<ReportsMiddle />} />
              {/* AUTHORIZATIONS */}
              <Route path="authorizations" element={<Authorizations />} />
              {/* SETTINGS */}
              <Route path="funds" element={<Funds />} />
              <Route path="tickers" element={<Tickers />} />
              <Route path="accounts" element={<Accounts />} />
              <Route path="sendauth" element={<SendAuth />} />
              <Route path="portfolioManagers" element={<PortfolioManagers />} />
            </Route>
          </Routes>
        </Router>
      </PusherProvider>
      </MyContext.Provider>
      }
    </div>
  );
}

export default App;
